import { Layout } from "antd";
import styled from "styled-components";

export const StyledHeader = styled(Layout.Header)`
  left: 240px;
  height: 60px;
  padding: 0;
  background: #ffffff;
  border-bottom: 1px solid #d7dce9;
`;
